// code "inspired" by https://github.com/paulirish/lite-youtube-embed
let isYoutubeStuffPrefetched = false;

function addPreconnect(url) {
  let linkEl = document.createElement('link');
  linkEl.rel = 'preconnect';
  linkEl.href = url;
  document.head.append(linkEl);
}

function prefetchStuff() {
  if (isYoutubeStuffPrefetched) return;
  addPreconnect('https://www.youtube-nocookie.com');
  addPreconnect('https://www.google.com');
  isYoutubeStuffPrefetched = true;
}

function addThumbnail(el, id) {
  const posterValue = el.getAttribute('data-youtube-poster') || null;
  if (!posterValue || posterValue == 'hd') {
    let thumbnailQuality = posterValue == 'hd' ? 'maxresdefault' : 'hqdefault';
    el.style.backgroundImage = `url(https://i.ytimg.com/vi/${id}/${thumbnailQuality}.jpg)`;
  } else {
    el.style.backgroundImage = `url(${el.getAttribute('data-youtube-poster')})`;
  }
}

function createButton(el) {
  let playBtnEl = document.createElement('button');
  playBtnEl.type = 'button';
  playBtnEl.classList.add('yl-btn');
  if (el.hasAttribute('data-youtube-label')) playBtnEl.setAttribute('aria-label',el.getAttribute('data-youtube-label'))
  el.append(playBtnEl);
}

function clickEvent(el, id) {
  const params = new URLSearchParams(el.getAttribute('data-youtube-params') || []);
  params.append('autoplay', '1');
  const iframeEl = document.createElement('iframe');
  iframeEl.width = 640;
  iframeEl.height = 360;
  iframeEl.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
  iframeEl.allowFullscreen = true;
  iframeEl.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${params.toString()}`;

  el.append(iframeEl);
  el.classList.add('is-active');
  el.querySelector('iframe').focus();

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'YouTube',
    'action': 'play',
    'label': document.location.href + ' https://www.youtube.com/watch?v=' + id
  });
}

function init() {
  document.querySelectorAll('[data-youtube-id]').forEach(videoEl => {
    let videoId = videoEl.getAttribute('data-youtube-id');

    addThumbnail(videoEl, videoId);
    createButton(videoEl);
    videoEl.addEventListener('pointerover', prefetchStuff, {once: true});
    videoEl.addEventListener('click', () => clickEvent(videoEl, videoId), {once: true});
  })
}

document.addEventListener('DOMContentLoaded', init);
